import FormattedMessage from 'I18n/components/FormattedMessage';
import * as links from 'documents-lib/js/lib/links';
import { canWrite } from 'documents-ui/lib/permissions';
import { isOwnedByCurrentUser } from 'documents-ui/utils/owner';
import useEditWarningModal from 'documents-ui/utils/useEditWarningModal';
import { isUngatedToCHIRPEndpoints } from 'documents-ui/utils/gates';
import * as EditWarningModalTypes from 'documents-ui/constants/EditWarningModalTypes';
import { Flex } from 'foundations-components/components/Flex';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Link } from 'foundations-components/transitional/components/Link';
import { useGetGdprWrapQuery, useUpdateSettingsMutation } from '../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsGDPRService.hooks';
import { GET_GDPR_WRAP_QUERY } from '../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentsGDPRService.dfc.new';
import { useGetSummaryAnalytics } from '../../hooks/useGetSummaryAnalytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryHeaderGDPRToggle = ({
  documentId,
  documentMetadata,
  gdprSettings: {
    deckId,
    legalConsentEnabled: legalConsentEnabledREST
  },
  updateDocumentGDPRSetting
}) => {
  var _documentAnalyticsSum;
  const isUngatedToChirp = isUngatedToCHIRPEndpoints();
  const {
    data: gdprSettingsCHIRP
  } = useGetGdprWrapQuery({
    variables: {
      documentId: deckId
    },
    // Don't call the hook if not ungated to CHIRP migration (or if deckId is not set)
    skip: !deckId || !isUngatedToChirp
  });
  const {
    data: documentAnalyticsSummary
  } = useGetSummaryAnalytics({
    documentId
  });
  const [updateSettingsMutation] = useUpdateSettingsMutation();

  // Drive the consent data from the CHIRP endpoint if ungated.
  const legalConsentEnabled = isUngatedToChirp ? gdprSettingsCHIRP === null || gdprSettingsCHIRP === void 0 ? void 0 : gdprSettingsCHIRP.legalConsentEnabled : legalConsentEnabledREST;
  function handleChange() {
    if (deckId && isUngatedToChirp) {
      void updateSettingsMutation({
        variables: {
          documentId: deckId,
          request: {
            legalConsentEnabled: !legalConsentEnabled
          }
        },
        // Update the cache so all instances of GET_GDPR_WRAP_QUERY will point to the new value
        update: (cache, {
          data: updatedSettingsData
        }) => {
          cache.writeQuery({
            query: GET_GDPR_WRAP_QUERY,
            variables: {
              documentId: deckId
            },
            data: updatedSettingsData
          });
        }
      });
    } else if (deckId) {
      updateDocumentGDPRSetting({
        deckId,
        legalConsentEnabled: !legalConsentEnabled
      });
    }
  }
  const userIdREST = documentMetadata.get('userId');
  const userIdCHIRP =
  // TODO: Verify that this is the equivalent of property
  (documentAnalyticsSummary === null || documentAnalyticsSummary === void 0 || (_documentAnalyticsSum = documentAnalyticsSummary.documentAnalyticsSummaryView) === null || _documentAnalyticsSum === void 0 ? void 0 : _documentAnalyticsSum.ownerId) || null;
  const userId = isUngatedToChirp ? userIdCHIRP : userIdREST;
  const owner = documentMetadata.get('user');
  const {
    editWarningModal,
    onChangeWithEditWarnings
  } = useEditWarningModal({
    documentId,
    type: EditWarningModalTypes.DATA_PRIVACY,
    showEditWarnings: !isOwnedByCurrentUser(userId),
    onConfirm: handleChange,
    owner,
    showIcon: false
  });
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    marginBlockEnd: "500",
    flexWrap: "wrap",
    children: [editWarningModal, /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "documentsUI.missingWriteScope.edit"
      }),
      disabled: canWrite(),
      placement: "bottom",
      children: /*#__PURE__*/_jsx(Toggle, {
        "data-selenium-test": "gdpr-enabled-toggle",
        "data-test-checked": legalConsentEnabled,
        checked: legalConsentEnabled,
        size: "extra-small",
        marginInlineEnd: "300",
        onChange: onChangeWithEditWarnings,
        readOnly: !canWrite(),
        id: "gdpr-toggle"
      })
    }), /*#__PURE__*/_jsx(FormLabel, {
      htmlFor: "gdpr-toggle",
      paddingInlineEnd: "100",
      paddingBlock: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.header.dataPrivacy.title"
      })
    }), /*#__PURE__*/_jsx(HelpIcon, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.header.dataPrivacy.help"
      }),
      tooltipProps: {
        placement: 'top'
      },
      marginInlineEnd: "300"
    }), /*#__PURE__*/_jsx(Link, {
      external: true,
      href: links.getGDPRUrl(),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "summary.header.dataPrivacy.learnMore"
      })
    })]
  });
};
export default SummaryHeaderGDPRToggle;